<style scoped>
.no-error-visible {
  display: none;
}

.btn.facebook {
  background-color: #3b5998;
}

.btn.facebook i {
  font-size: 1.5em;
}

.btn-full {
  width: 100%;
}

.divider {
  margin-top: 12px;
  margin-bottom: 12px;
}

.login-divider {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #f9f9f9;
  padding-left: 12px;
  padding-right: 12px;
}
#login-divider-container {
  position: relative;
  padding-top: 12px;
  padding-bottom: 12px;
}
.div-virtical {
  border-right: 1px solid lightgray;
}
.mrgnTop {
  margin-top: 192px;
}
.mrgnTxt {
  margin-bottom: 25px;
}

.btn-sub-label {
  display: block;
  margin-top: 8px;
}
.pdd-right {
  padding-right: 30px;
}
</style>

<template lang="pug">
div
  h5 Get the best drinks in towns
  .vertical-space-small
  v-row
    v-col.div-virtical.pdd-right(cols='12', sm='12')
      form.row(@submit.prevent='loginLocal')
        v-col(cols='12', sm='12')
          v-text-field#loginEmail(
            v-model='email',
            label='Email/ Username/ Client Code',
            name='loginEmail',
            placeholder='ex. john.doe@gmail.com',
            required
          )
        v-col(cols='12', sm='12')
          v-text-field#loginPassword(
            v-model='password',
            :append-icon='show1 ? "visibility" : "visibility_off"',
            :type='show1 ? "text" : "password"',
            name='loginPassword',
            label='Password',
            @click:append='show1 = !show1',
            required
          )
        v-col(cols='12', sm='12')
          label
            input(type='checkbox', name='reseller', v-model='reseller')
            span I am a Reseller
        .vertical-space-small
        v-col(cols='12', sm='12')
          button.btn.waves-effect.btn-full.indigo
            | Sign in
          p.right.mt-3
            a(href='#', @click='forgotPassword') Forgot your password?
        v-col#login-divider-container(cols='12', sm='12')
          .divider
          span.login-divider OR
        v-col(cols='12', sm='12')
          .vertical-space-small
          button.btn.social.btn-full.facebook.fa-btn.waves-effect(
            @click='facebookLogin'
          )
            i.fa.fa-facebook &nbsp;&nbsp;
            | Facebook
          label.btn-sub-label *Login with facebook registers you as a shopper

    //- .col.s6.mrgnTop
      //- a.btn.social.btn-full.facebook.fa-btn.waves-effect(
      //-   @click='facebookLogin')
      //-   i.fa.fa-facebook &nbsp;&nbsp;
      //-   | Facebook
</template>
<script>
const $ = require('jquery')
window.$ = $

export default {
  data() {
    return {
      redirect: null,
      email: '',
      password: '',
      attemptSubmit: false,
      reseller: false,
      status: 'application',
      show1: false,
    }
  },
  computed: {
    redirectUrl() {
      return this.$router.currentRoute.query.redirectUrl || '/'
    },
    hasEmail: function () {
      return this.email !== ''
    },
    hasPassword: function () {
      return this.password !== ''
    },
    validForm: function () {
      return this.hasEmail && this.hasPassword
    },
  },
  methods: {
    forgotPassword() {
      this.$router.push({
        name: 'request-password-reset',
        params: { usernameOrEmail: this.email },
      })
    },
    facebookLogin() {
      // disable for demo
      this.$store
        .dispatch('auth/facebookLogin', { scope: 'customer' })
        .then((user) => {
          if (user) {
            this.$router.replace(this.redirectUrl)
          }
        })
    },
    loginLocal() {
      if (this.reseller) {
        var scopetype = 'reseller'
      } else {
        scopetype = 'customer'
      }
      this.$store
        .dispatch('auth/localLogin', {
          email: this.email,
          password: this.password,
          scope: scopetype,
        })
        .then((user) => {
          // if (user.type !== 'customer' ) {
          //   this.$store.dispatch('auth/clear')
          //   throw new Error('Invalid account')
          // } else if (user) {
          //   this.$router.replace(this.redirectUrl)
          // }
          if (user.type === 'reseller') {
            if (user.type === 'reseller' && user.status === 'application') {
              this.$router.replace('/unauthorized')
              this.$store.dispatch('auth/clear')
            } else if (user.type === 'reseller' && user.status === 'disabled') {
              this.$snackbar.error('This account has been disabled')
              this.$store.dispatch('auth/clear')
            } else {
              this.$router.replace(this.redirectUrl)
            }
          } else if (user.type === 'customer') {
            this.$router.replace(this.redirectUrl)
          } else {
            this.$store.dispatch('auth/clear')
            throw new Error('Invalid account')
          }
        })
        .catch((error) => {
          this.$snackbar.error(error.message)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-customer-login.vue